export default __webpack_public_path__ + "static/media/pixeltrue-support.a8d0681f.svg";